import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  QuestionModalMessage,
  QuestionModalState,
} from '../../interfaces/connected-components/questionModal';
import {modalTypes} from '../../utils/enums';

const initialState: QuestionModalState = {
  isVisible: false,
  message: '',
  title: '',
  type: modalTypes.question,
  onConfirm: null,
  onReject: null,
  customHeaderComponent: undefined,
  confirmText: '',
  rejectText: '',
};

export const questionModalSlice = createSlice({
  name: 'questionModal',
  initialState,
  reducers: {
    showQuestionModal: (state, action: PayloadAction<QuestionModalMessage>) => {
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.isVisible = true;
      state.customHeaderComponent = action.payload.customHeaderComponent;
      state.type = action.payload.type;
      state.onConfirm = action.payload.onConfirm;
      state.confirmText = action.payload.confirmText;
      state.onReject = action.payload.onReject;
      state.rejectText = action.payload.rejectText;
    },
    hideQuestionModal: state => {
      state.isVisible = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {showQuestionModal, hideQuestionModal} =
  questionModalSlice.actions;

export default questionModalSlice.reducer;
